// Get inbois by date range, zon, and department
export const apiGetInboisByDateRangeZon = async (tarikh_mula, tarikh_tamat, zon) => {
  const response = await fetch(
    `${API_BASE_URL}/inbois/by-date-range-zon?tarikh_mula=${encodeURIComponent(tarikh_mula)}&tarikh_tamat=${encodeURIComponent(tarikh_tamat)}&zon=${encodeURIComponent(zon)}`,
    {
      method: "GET",
      headers: getApiHeaders(),
    }
  );
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return await response.json();
};
// Get max no_inbois where no_inbois LIKE '4%' and ends with a digit
export const apiGetMaxNoInboisLike4 = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/inbois/max-no-inbois-like-4`,
      {
        method: "GET",
        headers: getApiHeaders(),
      }
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data.maxNoInbois;
  } catch (error) {
    console.error("Error fetching max no_inbois like 4:", error);
    throw error;
  }
};

// Get unpaid inbois for a given no_akaun
export async function getUnpaidInboisByNoAkaun(noAkaun) {
  const response = await fetch(`${API_BASE_URL}/inbois/unpaid/${encodeURIComponent(noAkaun)}`, {
    method: "GET",
    headers: getApiHeaders(),
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return await response.json();
}

// Update inbois by id
export const apiUpdateInbois = async (id, data) => {
  try {
    const response = await fetch(`${API_BASE_URL}/inbois/${id}`, {
      method: "PUT",
      headers: await withCsrfHeaders(getApiHeaders()),
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error updating inbois:", error);
    throw error;
  }
};
// Get inbois by no_inbois
export async function apiGetInboisByNoInbois(no_inbois) {
  const response = await fetch(`/api/inbois/by-no-inbois/${encodeURIComponent(no_inbois)}`);
  if (!response.ok) {
    throw new Error("Gagal memuatkan maklumat inbois.");
  }
  return response.json();
}
// Get max no_inbois for a given perkara
export const apiGetMaxNoInbois = async (perkara) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/inbois/max-no-inbois?perkara=${encodeURIComponent(perkara)}`,
      {
        method: "GET",
        headers: getApiHeaders(),
      }
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data.maxNoInbois;
  } catch (error) {
    console.error("Error fetching max no_inbois:", error);
    throw error;
  }
};

// Delete inbois by array of IDs
export const apiHapusInbois = async (ids) => {
  try {
    const response = await fetch(`${API_BASE_URL}/inbois`, {
      method: "DELETE",
      headers: await withCsrfHeaders(getApiHeaders()),
      body: JSON.stringify({ ids }),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error deleting inbois:", error);
    throw error;
  }
};
// API for Inbois data
import { API_BASE_URL } from "./base";
import { withCsrfHeaders } from "./csrf";

const getApiHeaders = () => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const userDepartment = user.bahagian;
  if (!userDepartment) throw new Error("bahagian_pemantau diperlukan");
  return {
    "Content-Type": "application/json",
    "X-User-Department": userDepartment,
  };
};

export const apiGetInboisByNoAkaun = async (noAkaun) => {
  try {
    const response = await fetch(`${API_BASE_URL}/inbois/noakaun/${encodeURIComponent(noAkaun)}`, {
      method: "GET",
      headers: getApiHeaders(),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching inbois by account number:", error);
    throw error;
  }
};

export const apiTambahInbois = async (inboisData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/inbois`, {
      method: "POST",
      headers: await withCsrfHeaders(getApiHeaders()),
      body: JSON.stringify(inboisData),
    });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const errorMessage = errorData.error || `HTTP error! status: ${response.status}`;
      throw new Error(errorMessage);
    }
    return await response.json();
  } catch (error) {
    console.error("Error creating inbois:", error);
    throw error;
  }
};
// Removed temporary apiCheckPostedInbois helper
